import { AtImage, OrVideo } from 'src/graphql/generated/graphql';
import { Asset } from 'src/graphql/queries/GetRoleCollection';

export interface ImageAttrs {
  src: string;
  alt: string;
}

interface VideoAttrs {
  cdnCaptions: string;
  cdnUrl: string;
  vimeoUrl: string;
  youtubeUrl: string;
  thumbnailUrl: string;
}

interface InspectModeContentful {
  [key: string]: {
    entryId: string;
    fieldId: string;
  };
}

export const getInspectModeData = (
  entry: { sys: { id: string } } | undefined,
  fieldsIds: string[],
): InspectModeContentful | undefined => {
  const data = {};

  if (entry && entry?.sys && entry.sys.id) {
    fieldsIds.forEach((fieldId) => {
      const entryId = entry.sys.id;

      if (entryId) {
        Object.assign(data, { [fieldId]: { entryId, fieldId } });
      }
    });

    return data;
  }
};

export const getImageAttrs = (asset: AtImage | Asset | undefined): ImageAttrs | undefined => {
  if (!asset) {
    return undefined;
  }

  const imageAttr = {
    alt: asset.altText,
  };

  if (asset.orangeLogicAsset) {
    return {
      ...imageAttr,
      src: asset.orangeLogicAsset.imageUrl,
    };
  }

  if (asset.cdnUrl) {
    return {
      ...imageAttr,
      src: asset.cdnUrl,
    };
  }

  return {
    ...imageAttr,
    src: asset.image?.url || '',
  };
};

export const getVideoAttrs = (videoData: OrVideo | undefined): VideoAttrs | undefined => {
  if (!videoData) {
    return undefined;
  }

  const videoAttrs = {
    cdnCaptions: videoData.captionCdnUrl || '',
    thumbnailUrl: videoData.banner || '',
    cdnUrl: '',
    vimeoUrl: '',
    youtubeUrl: '',
  };

  if (videoData.orangeLogicAsset) {
    return {
      ...videoAttrs,
      cdnUrl: videoData.orangeLogicAsset.imageUrl,
      cdnCaptions: videoData.orangeLogicCaptions.imageUrl,
      thumbnailUrl: videoData.orangeLogicAsset.extraFields['CoreField.OriginalPreview'] || '',
    };
  }

  if (videoData.cdnUrl) {
    return {
      ...videoAttrs,
      cdnUrl: videoData.cdnUrl,
    };
  }

  if (videoData.vimeoUrl) {
    return {
      ...videoAttrs,
      vimeoUrl: videoData.vimeoUrl,
    };
  }

  return {
    ...videoAttrs,
    youtubeUrl: videoData.youtubeUrl,
  };
};
